export const SCENARIO_PROMPT_VARIABLES = [
  "{{today_bg}}",
  "{{current_month_days}}",
  "{{next_month_days}}",
  "{{first_name}}",
  "{{last_name}}",
  "{{full_name}}",
  "{{phone}}",
  "{{all_creditors}}",
  "{{bank_creditors}}",
  "{{non_bank_creditors}}",
  "{{debt_paid}}",
  "{{no_payment_reported_phrase}}",
  "{{third_person_first_name}}",
  "{{third_person_last_name}}",
  "{{third_person_full_name}}",
  "{{third_person_phone}}",
  "{{call_history}}",
  "{{notes}}",
];
